import h from "./_MapCache.js";
var p = "Expected a function";
function o(r, e) {
  if (typeof r != "function" || e != null && typeof e != "function")
    throw new TypeError(p);
  var t = function() {
    var c = arguments, n = e ? e.apply(this, c) : c[0], a = t.cache;
    if (a.has(n))
      return a.get(n);
    var i = r.apply(this, c);
    return t.cache = a.set(n, i) || a, i;
  };
  return t.cache = new (o.Cache || h)(), t;
}
o.Cache = h;
export {
  o as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/memoize.js
// module id = 1569
// module chunks = 67